export default __webpack_public_path__ + "static/media/flagBrazil.9de13cc0.svg";